import { Types } from "../actions/groupActions";
import _ from "lodash";

const groupReducers = (state, action) => {
  switch (action.type) {

    case Types.GROUP_OPEN_MODAL: {

      let newState = _.cloneDeep(state);

      newState.pensions.group.modalState = action.status;
      newState.pensions.group.modalGroup = action.group;

      return newState;
    }

    case Types.GROUP_SAVING: {
      let newState = _.cloneDeep(state)

      newState.pensions.group.modalSaving = action.id ? true : false

      return newState
    }

    case Types.GROUP_SAVE_CURRENT: {
      let newState = _.cloneDeep(state)


      newState.pensions.group.modalSaving = false
      newState.pensions.group.modalState = {}

      return newState
    }

    case Types.GROUP_DELETE_MODAL: {

      let newState = _.cloneDeep(state);

      newState.pensions.group = { ...newState.pensions.group, deleteGroupModal: {
        show: action.status,
        group: action.group,
      }};

      return newState;
    }

    case Types.GROUP_DELETING: {

      let newState = _.cloneDeep(state);

      newState.pensions.group = {
        ...newState.pensions.group, deleteGroupModal: {
          ...newState.pensions.group.deleteGroupModal,
          deleting: true
        }
      };

      return newState;
    }

    case Types.GROUP_DELETED: {

      let newState = _.cloneDeep(state);

      newState.pensions.group = {
        ...newState.pensions.group,
        deleteGroupModal: {
          ...newState.pensions.group.deleteGroupModal,
          deleting: false,
        },
      };

      return newState;
    }

    case Types.GROUP_CONFIRM_CHANGE_MODAL: {

      let newState = _.cloneDeep(state);

      newState.pensions.group = { ...newState.pensions.group, confirmModal: {
        input: action.input,
        status: action.status,
        type: action.formType,
      }};

      return newState;
    }

    case Types.GROUP_UPDATING: {
      let newState = _.cloneDeep(state)

      newState.pensions.group.groupUpdating = true

      return newState
    }

    case Types.GROUP_UPDATE: {

      let newState = _.cloneDeep(state);
      const schemes = newState.pensions?.scheme?.list;

      newState.pensions.group.list = action.data?.map(group => {

        const scheme = schemes.find(s => s.id === group.scheme);

        return {
          ...group,
          paySchedule: scheme?.paySchedule,
        }
      });
      newState.pensions.group.groupUpdating = false

      return newState;
  }

    default:
      return state;
  }
};

export default groupReducers;